<div class="flex flex-col h-full"
     data-test="member-detail-view"
     [formGroup]="memberForm"
>
  <section class="detailview-summary"
           data-test="member-summary"
  >
    <p class="detailview-summary-name"
       data-test="member-name-summary"
    >
      {{ insuredDisplayName() }}
    </p>
    <p class="detailview-summary-meta">
      <span class="detailview-summary-meta-label">External-ID: </span>
      <span class="detailview-summary-meta-value"
            data-test="member-external-id-summary"
      >
        {{ memberForm.controls.externalId.value || '-' }}
      </span>
    </p>
  </section>

  <div class="detailview-toolbar md:pl-4 md:pr-4 sticky z-13">
    <div class="detailview-toolbar-inner flex gap-2 p-4 bg-white rounded-md border border-gray-300">
      <albert-section-navigation [sectionControl]="sectionControl"/>
      @if (isCreateMode()) {
        <div class="actions-row flex justify-end gap-2 ml-auto flex-wrap">
          <button data-test="save-button"
                  pButton
                  severity="success"
                  type="button"
                  [disabled]="!canSave()"
                  (click)="onSave()"
          >
            <i class="pi pi-save"></i>
            Speichern
          </button>
        </div>
      }
    </div>
  </div>

  <div class="md:p-4 pt-4 mx-auto w-full grow">
    <div class="col-span-full">
      <albert-textarea data-test="member-comment"
                       groupName="comment"
                       inputId="comment"
                       [disabled]="!canEdit()"
                       [label]="'Internal Comment ' + activeCategory()?.label"
                       [rows]="5"
      />
    </div>
    <div class="hidden md:grid grid-cols-2 gap-8 mb-2 font-bold tracking-wider">
      <div class="detailview-data-type-headlines">Origami Data</div>
      <div class="pl-4 detailview-data-type-headlines">Application Data & Overwrites</div>
    </div>

    <p-accordion data-test="insured-accordion"
                 [multiple]="true"
                 [value]="nav.activePanels()"
                 (valueChange)="nav.setActivePanels($event)"
    >
      @for (section of sections; track section.type; let mainIndex = $index) {
        @let panelValue = mainIndex.toString();
        <p-accordion-panel [attr.data-test]="'accordion-panel-' + section.dataTest"
                           [value]="panelValue"
        >
          <div #accordionPanel
               class="accordion-panel-scroll-target"
               [attr.data-index]="nav.getSectionIndex(mainIndex)"
          ></div>
          <p-accordion-header [attr.data-test]="'accordion-header-' + section.dataTest">
            <p class="section-title coverage-headline">{{ section.label }}</p>
          </p-accordion-header>
          <p-accordion-content [attr.data-test]="'accordion-content-' + section.dataTest">
            @switch (section.type) {
              @case ('POLICY') {
                <albert-period data-test="albert-period-component"
                               [form]="periodForm"
                               [isCreateMode]="isCreateMode()"
                               [memberExternalId]="memberForm.controls.externalId.value"
                               [periodOptions]="periodOptions()"
                               [policyStatus]="policyForm.controls.status.value"
                />
                <albert-policy data-test="albert-policy-component"
                               [form]="policyForm"
                               [isCreateMode]="isCreateMode()"
                               [memberExternalId]="memberForm.controls.externalId.value"
                               [policyOptions]="policyOptions()"
                               [policyStatus]="policyForm.controls.status.value"
                />
              }
              @case ('MEMBER') {
                <albert-member data-test="albert-member-component"
                               [form]="memberForm"
                               [isCreateMode]="isCreateMode()"
                               [memberExternalId]="memberForm.controls.externalId.value"
                               [policyStatus]="policyForm.controls.status.value"
                />
              }
              @case ('AVIATION_HULL') {
                @if (nav.activePanels().includes(panelValue)) {
                  <albert-aviation-hull-form
                    [expandAllPanels]="true"
                    [form]="aviationHullForm"
                    [isCreateMode]="isCreateMode()"
                    [mainIndex]="mainIndex"
                    [memberExternalId]="memberForm.controls.externalId.value"
                    [policyStatus]="policyForm.controls.status.value"
                  />
                }
              }
              @case ('AVIATION_LIABILITIES') {
                @if (nav.activePanels().includes(panelValue)) {
                  <albert-aviation-liabilities-form
                    [expandAllPanels]="true"
                    [form]="aviationLiabilitiesForm"
                    [isCreateMode]="isCreateMode()"
                    [mainIndex]="mainIndex"
                    [memberExternalId]="memberForm.controls.externalId.value"
                    [policyStatus]="policyForm.controls.status.value"
                  />
                }
              }
              @case ('COMMERCIAL_GENERAL_LIABILITY') {
                @if (nav.activePanels().includes(panelValue)) {
                  <albert-commercial-general-liability-form
                    [expandAllPanels]="true"
                    [form]="commercialGeneralLiabilityForm"
                    [isCreateMode]="isCreateMode()"
                    [mainIndex]="mainIndex"
                    [memberExternalId]="memberForm.controls.externalId.value"
                    [policyStatus]="policyForm.controls.status.value"
                  />
                }
              }
              @case ('OBJECTS') {
                <albert-fleet-list data-test="albert-fleet-list-component"
                                   [policyId]="policyForm.controls.uuid.value"
                                   [rendered]="nav.activePanels().includes(panelValue)"
                />
              }
            }
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>
</div>
